import React from 'react';
import { Hero } from '../components/home/Hero';
import { TrustBar } from '../components/home/TrustBar';
import { HowItWorks } from '../components/home/HowItWorks';
import { ServicesOverview } from '../components/home/ServicesOverview';
import { InsightsPreview } from '../components/home/InsightsPreview';
import { FounderNote } from '../components/home/FounderNote';
import { LocationsStrip } from '../components/home/LocationsStrip';
import { ClosingCTA } from '../components/ClosingCTA';
export function Home() {
  return <main data-id="element-351" data-mp="24htocbofwgee">
      <Hero data-id="element-352" data-mp="24hk83ft75nlw" />
      <TrustBar data-id="element-353" data-mp="24haeli8y0ybg" />
      <HowItWorks data-id="element-354" data-mp="24ivapcawopbf" />
      <ServicesOverview data-id="element-355" data-mp="29gdeypdzagd3" />
      <InsightsPreview data-id="element-356" data-mp="29f27aehewogp" />
      <FounderNote data-id="element-357" data-mp="29etuemlahj5i" />
      <LocationsStrip data-id="element-358" data-mp="29ihq9se7ihne" />
      <ClosingCTA data-id="element-359" data-mp="2dhgo6t1ite5c" />
    </main>;
}